import Style from './index.module.less'
const SeeTransBtn = ({ btnName, onClick }: { btnName: string; onClick: () => void }) => {
  return (
    <div
      className={Style.wrap}
      onClick={() => {
        onClick()
      }}
    >
      <span>{btnName}</span>
      <span className={Style.rightIcon}></span>
    </div>
  )
}

export default SeeTransBtn
